import clsx from 'clsx';
import { useEffect, useState } from 'react';
import { X } from 'react-feather';
import { useForm } from 'react-hook-form';
import Modal from 'react-modal';
import { useNavigate } from 'react-router-dom';
import { CreateInvoiceFromDeliveryNotesDto } from '../interfaces/create-invoice-from-delivery-notes.dto';
import { DeliveryNote } from '../interfaces/delivery-note';
import { api } from '../services/api';
import myToastr from '../services/toastr';
import { useAppSelector } from '../store/hooks';
import { RootState } from '../store/store';

interface CreateInvoiceFromDeliveryNotesModalProps {
  deliveryNotes: DeliveryNote[];
  onClose: () => void;
  open: boolean;
}

const CreateInvoiceFromDeliveryNotesModal = ({ deliveryNotes, onClose, open }: CreateInvoiceFromDeliveryNotesModalProps) => {
  const navigate = useNavigate();
  const { user } = useAppSelector((state: RootState) => state.auth);
  const [requesting, setRequesting] = useState(false);

  const {
    formState: { errors },
    handleSubmit,
    register,
    reset,
  } = useForm<CreateInvoiceFromDeliveryNotesDto>({
    defaultValues: {
      deliveryNoteIds: deliveryNotes.map((dn) => dn.id),
      storeId: -1,
    },
  });

  useEffect(() => {
    if (open && user) {
      reset({
        deliveryNoteIds: deliveryNotes.map((dn) => dn.id),
        storeId: user.stores.length === 1 ? user.stores[0].id : -1,
      });
    }
  }, [open, deliveryNotes, reset, user]);

  const onSubmit = async (formData: CreateInvoiceFromDeliveryNotesDto) => {
    try {
      setRequesting(true);
      const invoiceId = await api.createInvoiceFromDeliveryNotes(formData);
      myToastr.success('Factura creada correctamente');
      navigate(`/factura/${invoiceId}`);
    } catch (e: any) {
      setRequesting(false);
      myToastr.error(e.response.data.message);
    }
  };

  return (
    <Modal className="vercomi-modal my-form brand-modal" isOpen={open} onRequestClose={() => onClose()} shouldCloseOnOverlayClick={false}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="content">
          <div className="d-flex justify-content-between mb-3">
            <div className="title">Crear factura desde albaranes</div>
            <button className="close-button-modal" disabled={requesting} onClick={() => onClose()} title="Cerrar" type="button">
              <X size={16} />
            </button>
          </div>
          <div className="row my-3">
            <div className="col">
              <div className={clsx('input-name', { error: errors?.storeId })}>Tienda *</div>
              <select
                {...register('storeId', {
                  required: 'La tienda es obligatoria',
                  min: {
                    value: 1,
                    message: 'Campo obligatorio',
                  },
                  valueAsNumber: true,
                })}
                className={clsx({ error: errors?.storeId })}
              >
                <option value={-1}>Seleccione una tienda</option>
                {user?.stores.map((store) => (
                  <option key={store.id} value={store.id}>
                    {store.name}
                  </option>
                ))}
              </select>
              {errors.storeId && <div className="error-message">{errors.storeId.message}</div>}
            </div>
          </div>
        </div>
        <button className={`save-button`} disabled={requesting} type="submit">
          Guardar
        </button>
      </form>
    </Modal>
  );
};

export default CreateInvoiceFromDeliveryNotesModal;
